import React from 'react';
import {
  Route,
  Routes,
  Outlet,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import ResetPassword from './resetPassword';
import Activation from './activationNewPassword';
import LoginForm from './userLogin';
import DontHavePassword from './dontHavePassword';
import Logout from './Logout';
import ReadQR from '../../containers/services/ReadQR';

function LoginRoutes({ onLogin }) {
  return (
    <Routes>
      <Route element={<Outlet />}>

        <Route
          path="/resetPassword/"
          element={<ResetPassword />}
        />
        <Route
          path="/logout/"
          element={<Logout />}
        />
        <Route
          path="/authentication/card/register"
          element={<DontHavePassword />}
        />
        <Route
          path="/password/reset/confirm/:uid/:activateToken"
          element={<Activation />}
        />
        <Route
          path="/qr/:uid"
          element={<ReadQR />}
        />
        <Route
          // exact
          path="*"
          element={<LoginForm onLogin={onLogin} />}
        />

      </Route>
    </Routes>
  );
}

LoginRoutes.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default LoginRoutes;
